import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from "react-router-dom";
import appConfig from '../../config/appConfig';
import { useTranslation } from 'react-i18next';
import InfirmationTable from '../components/InfirmationTable';
import HeaderTablePage from '../components/HeaderTablePage';
import LoadingTable from '../components/LoadingTable';
import EmptyTable from "../components/EmptyTable";
import axios from 'axios';
import { verifyPermission } from '../../helpers/permission';


const SocialMediaConfig = (props) => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const [load, setLoad] = useState(false);
    const [listSocialMediaConfig, setListSocialMediaConfig] = useState([]);


    const printBodyTable = (listSocialMedia, index) => {
        return (
        <tr key={index} role="row" className="odd">
            <td>{listSocialMedia.institution.name}</td>
            <td>
                {
                    (listSocialMedia.facebook_configs==null || ( typeof listSocialMedia.facebook_configs == "object" && listSocialMedia.facebook_configs.length==0)) ? "NON" : "OUI"
                }
            </td>
            <td>
                {
                    (listSocialMedia.whatsapp_configs==null || ( typeof listSocialMedia.whatsapp_configs == "object" && listSocialMedia.whatsapp_configs.length==0)) ? "NON" : "OUI"
                }
            </td>
            <td>
                {
                    (listSocialMedia.linkedin_configs==null || ( typeof listSocialMedia.linkedin_configs == "object" && listSocialMedia.linkedin_configs.length==0)) ? "NON" : "OUI"
                }
            </td>
            
            <td>
                {verifyPermission(props.userPermissions, "update-severity-level") ? (
                    <Link
                        to={`/settings/social-medias/${listSocialMedia.id}/edit`}
                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                        title={t("Modifier")}
                    >
                        <i className="la la-edit" />
                    </Link>
                ) : null}
            </td>
        </tr>
        );
    };

    // END POINT
    const getSocialMediaEndpoint = `${appConfig.apiDomaine}/social-network/configs`;

    const getAllSocialMediaConfig = async() => {
        axios
        .get(getSocialMediaEndpoint)
        .then((response) => {
            setListSocialMediaConfig(response.data);
            setLoad(false);
        })
        .catch((error) => {
            console.log(error);
            setLoad(false);
        });
    };

    useEffect(() => {
        setLoad(true);
        getAllSocialMediaConfig();
    }, []);
    


    return (
        <div
            className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >
            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#icone" className="kt-subheader__breadcrumbs-home">
                                <i className="flaticon2-shelter" />
                            </a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a
                                href="#button"
                                onClick={(e) => e.preventDefault()}
                                className="kt-subheader__breadcrumbs-link"
                                style={{ cursor: "text" }}
                            >
                                {t("Configurations réseaux sociaux ")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <InfirmationTable
                    information={t(
                        "Paramètre de configuration des réseaux sociaux"
                    )}
                />

                <div className="kt-portlet">
                    <HeaderTablePage
                        addPermission=""
                        title={t("Configuration des réseaux sociaux")}
                    />

                    {
                        load ? <LoadingTable /> : (
                            <div className="kt-portlet__body">
                                <div
                                    id="kt_table_1_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                >
                                    
                                    <div className='d-flex justify-content-end'>
                                        
                                        <Link
                                            to="/settings/social-medias/add"
                                            className="btn btn-primary"
                                        >
                                            <i className="la la-plus" /> 
                                            {t("Ajouter")}
                                        </Link>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <table
                                                className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                                                id="myTable"
                                                role="grid"
                                                aria-describedby="kt_table_1_info"
                                                style={{ width: "952px" }}
                                            >
                                                <thead>
                                                    <tr role="row">
                                                        <th
                                                            className="sorting"
                                                            tabIndex="0"
                                                            aria-controls="kt_table_1"
                                                            rowSpan="1"
                                                            colSpan="1"
                                                            style={{ width: "70.25px" }}
                                                            aria-label=""
                                                        >
                                                            {t("Nom de l'institution")}
                                                        </th>
                                                        <th
                                                            className="sorting"
                                                            tabIndex="0"
                                                            aria-controls="kt_table_1"
                                                            rowSpan="1"
                                                            colSpan="1"
                                                            style={{ width: "70.25px" }}
                                                            aria-label=""
                                                        >
                                                            {t("Facebook")}
                                                        </th>
                                                        <th
                                                            className="sorting"
                                                            tabIndex="0"
                                                            aria-controls="kt_table_1"
                                                            rowSpan="1"
                                                            colSpan="1"
                                                            style={{ width: "70.25px" }}
                                                            aria-label=""
                                                        >
                                                            {t("Whatsapp")}
                                                        </th>
                                                        <th
                                                            className="sorting"
                                                            tabIndex="0"
                                                            aria-controls="kt_table_1"
                                                            rowSpan="1"
                                                            colSpan="1"
                                                            style={{ width: "70.25px" }}
                                                            aria-label=""
                                                        >
                                                            {t("Linkedin")}
                                                        </th>
                                                        <th
                                                            className="sorting"
                                                            tabIndex="0"
                                                            aria-controls="kt_table_1"
                                                            rowSpan="1"
                                                            colSpan="1"
                                                            style={{ width: "40.25px" }}
                                                            aria-label=""
                                                        >
                                                            {t("Action")}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        listSocialMediaConfig.length > 0 ? (
                                                            listSocialMediaConfig.map((listSocialMedia, index) =>
                                                                printBodyTable(listSocialMedia, index)
                                                            )
                                                        ) : (
                                                            <EmptyTable />
                                                        )
                                                    }
                                                    
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th rowSpan="1" colSpan="1">
                                                            {t("Nom de l'institution")}
                                                        </th>
                                                        <th rowSpan="1" colSpan="1">
                                                            {t("Facebook")}
                                                        </th>
                                                        <th rowSpan="1" colSpan="1">
                                                            {t("Whatsapp")}
                                                        </th>
                                                        <th rowSpan="1" colSpan="1">
                                                            {t("Linkedin")}
                                                        </th>
                                                        <th rowSpan="1" colSpan="1">
                                                            {t("Action")}
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(SocialMediaConfig)